import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Check, Times } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import { FormField, FormFields } from '../../../components/FormFields';
import { Input } from '../../../components/Input';
import { Button } from '../../../components/Buttons';
import { deleteVehicleProperty, fetchVehiclePropertyNames, setVehicleProperty } from '../actions';
import _ from 'lodash';
import { isNumeric } from '../../../utils/string';
import { selectVehiclePropertyNames } from '../selectors';
import { Dropdown } from '../../../components/Dropdown';

const STATE = {
  edit: null,
  value: '',
  add: false,
  addValue: '',
  confirmRemove: false,
};

const Container = styled.div`
  min-width: 600px;
`;

const parsePropertyValue = function(value) {
  //todo: move parsing to API
  //basic parsing ... (should probably be done at api level?)

  if (value === 'false') value = false;
  if (value === 'true') value = true;
  if (isNumeric(value)) value = parseFloat(value);
  return value;
};

export const Property = styled.div`
  > .box {
    border-bottom: 1px solid #ddd;
  }
  .name {
    margin-right: 12px;
    width: 200px;
    min-width: 200px;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehiclePropertiesEditorComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.fetch();
  }

  editProperty(property) {
    this.setState({ edit: property.id, value: property.propertyValue?.value ?? '' });
  }

  reset() {
    this.setState({ ...STATE });
  }

  get vehicle() {
    return this.props.vehicle;
  }

  save() {
    let value = parsePropertyValue(this.state.value);

    this.props.save(
      this.vehicle.properties.find(p => p.id === this.state.edit).propertyName.name,
      value,
      this.reset.bind(this),
    );
  }

  toOne() {
    this.setState({ value: 1 }, this.save.bind(this));
  }

  remove() {
    if (!this.state.confirmRemove) return this.setState({ confirmRemove: true });

    this.props.remove(this.vehicle.properties.find(p => p.id === this.state.edit).propertyName.name, this.reset.bind(this));
  }

  add() {
    const name = this.props.vehiclePropertyNames.find(p => p.id === this.state.addPropertyNameId).name;
    let value = parsePropertyValue(this.state.addValue);
    this.props.save(name, value, this.reset.bind(this));
  }

  render() {
    const vehicle = this.props.vehicle;
    if (!vehicle) return null;
    return (
      <Container>
        {this.state.add ? this.renderAdd() : null}
        <h3>{this.lbl('vehicle.details.properties')}:</h3>
        <div>
          <Button small onClick={this.setStateFn({ add: true })}>
            +
          </Button>
        </div>
        <VBox>{vehicle.properties.map(p => this.renderProperty(p))}</VBox>
      </Container>
    );
  }

  renderAdd() {
    const options = this.props.vehiclePropertyNames?.map(prop => ({ label: prop.name, value: prop.id }));
    const selected = options.find(o => o.value == this.state.addPropertyNameId);
    if (!options || !options.length) return null;
    return (
      <Modal onClose={this.reset.bind(this)} title={this.lbl('vehicle.property.add')}>
        <Dropdown options={options} onChange={o => this.setState({ addPropertyNameId: o.value })} value={selected} />
        {selected ? (
          <FormField>
            <Input name="addValue" value={this.state.addValue} onChange={this.onInputChange.bind(this)} />
          </FormField>
        ) : null}
        <ModalControls>
          <Button primary disabled={!selected} onClick={this.add.bind(this)}>
            Save
          </Button>
          <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  renderProperty(property) {
    const value = property.propertyValue?.value || null;

    if (this.state.edit === property.id) return this.renderEditProperty(property);
    return (
      <Property key={`${property.id}`} onClick={() => this.editProperty(property)}>
        <HBox>
          <div className="name">{property.propertyName.name}</div>
          <div className="value">
            {value === true ? <Check /> : value === false ? <Times /> : _.isObject(value) ? JSON.stringify(value) : value}
          </div>
        </HBox>
      </Property>
    );
  }

  renderEditProperty(property) {
    return (
      <Modal key={property.id} onClose={this.reset.bind(this)} title={this.lbl('vehicle.property.edit')}>
        {this.state.confirmRemove ? (
          <>
            Verwijderen?
            <br />
            <Button onClick={this.remove.bind(this)}>{this.lbl('delete')}</Button>
            <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
          </>
        ) : (
          <>
            <FormFields>
              <h1>{property.propertyName.name}</h1>
              <FormField>
                <Input value={this.state.value} name="value" onChange={this.onInputChange.bind(this)} />
              </FormField>
            </FormFields>
            <ModalControls>
              <Button onClick={this.toOne.bind(this)}>1</Button>
              <Button onClick={this.remove.bind(this)}>X</Button>
              <Button primary onClick={this.save.bind(this)}>
                Save
              </Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </ModalControls>
          </>
        )}
      </Modal>
    );
  }
}

VehiclePropertiesEditorComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    vehiclePropertyNames: selectVehiclePropertyNames(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehiclePropertyNames());
    },
    save(property_name, value, cb) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, property_name, value, cb));
    },
    remove(property_name, callback) {
      dispatch(deleteVehicleProperty(ownProps.vehicle.id, property_name, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehiclePropertiesEditor = compose(withConnect, withRouter)(VehiclePropertiesEditorComp);
